function roundTo(n, digits) {
    let negative = false;

    if (digits === undefined) {
        digits = 0;
    }

    if (n < 0) {
        negative = true;
        n = n * -1;
    }

    let multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(digits);

    return negative ? (n * -1).toFixed(digits) : n;
}

document.addEventListener('DOMContentLoaded', () => {
    let car_replacement_request_form = document.querySelector('form.cms_car_replacement_request');

    if (car_replacement_request_form !== null) {
        let rental_start_date_input = car_replacement_request_form.querySelector('#cms_car_replacement_request_rental_start_date'),
            rental_end_date_input = car_replacement_request_form.querySelector('#cms_car_replacement_request_rental_end_date'),
            number_of_days_input = car_replacement_request_form.querySelector('#cms_car_replacement_request_number_of_days'),
            daily_rate_including_vat_input = car_replacement_request_form.querySelector('#cms_car_replacement_request_daily_rate_including_vat'),
            total_due_amount_input = car_replacement_request_form.querySelector('#cms_car_replacement_request_total_due_amount');

        function rental_date_change_handler() {
            if (rental_start_date_input.value === "" || rental_end_date_input.value === "") {
                number_of_days_input.value = 0;
                return;
            }

            let rental_start_date_value = new Date(rental_start_date_input.value);
            let rental_end_date_value = new Date(rental_end_date_input.value);
            let diffTime = Math.abs(rental_end_date_value - rental_start_date_value);
            number_of_days_input.value = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }

        function recalculate_total_due_amount() {
            let number_of_days_value = Number(number_of_days_input.value);
            let daily_rate_including_vat_value = Number(daily_rate_including_vat_input.value);

            if (isNaN(number_of_days_value) || isNaN(daily_rate_including_vat_value)) {
                total_due_amount_input.value = 0;
            } else {
                total_due_amount_input.value = roundTo(number_of_days_value * daily_rate_including_vat_value, 2);
            }
        }

        function handler() {
            rental_date_change_handler()
            recalculate_total_due_amount()
        }

        rental_start_date_input.onchange = function () {
            handler()
        }

        rental_end_date_input.onchange = function () {
            handler()
        }

        daily_rate_including_vat_input.onchange = function () {
            handler()
        }

        handler()
    }
});
